module.exports = __webpack_public_path__ + "img/link-azul.6e3e4c51.svg";